<template>
    <div id="index" :class="{ 'mobile' : mobile}">
        <div id="navigation_mobile" v-if="mobile">
            <div class="menu_bar">
                <table width="100%">
                    <tr>
                        <td>
                            <i class="fas fa-bars hamburger" v-on:click="open_mobile_menu"></i>
                        </td>
                        <td align="right">
                            <div class="icon"></div>
                        </td>
                    </tr>
                </table>
            </div>
            <nav id="mobile_menu_links">
                <router-link to="/" draggable="false" ondragstart="return false;" @click.native="change_url($event)"><i class="fas fa-home"></i><span>Hem</span></router-link>
                <router-link to="/information" draggable="false" ondragstart="return false;" @click.native="change_url($event)"><i class="fas fa-info-circle"></i><span>Information</span></router-link>
                <router-link to="/uppdrag" draggable="false" ondragstart="return false;" @click.native="change_url($event)"><i class="fas fa-briefcase"></i><span>Tillgängliga Uppdrag</span></router-link>
                <router-link to="/anlita_oss" draggable="false" ondragstart="return false;" @click.native="change_url($event)"><i class="fas fa-sitemap"></i><span>Anlita Oss</span></router-link>
                <router-link to="/kontakta_oss" draggable="false" ondragstart="return false;" class="end-piece" @click.native="change_url($event)"><i class="fas fa-envelope"></i><span>Kontakta Oss</span></router-link>
                <router-link to="/mina_sidor" draggable="false" ondragstart="return false;" class="end-piece" @click.native="change_url($event, 'left')"><i class="fas fa-user-circle"></i><span>Mina Sidor</span></router-link>
            </nav>
        </div>
        <div id="navigation" v-else>
            <div class="container header_info">
                <table>
                    <tr>
                        <td>
                            <img src="./assets/asas_logo.svg" />
                        </td>
                        <td align="right">
                            <div class="contact_us">
                                Ring Oss: 0225 - 25 44 00<br />
                                Maila Oss: <a href="mailto:kontakt@asasbemanning.se" target="_blank" style="color: #000000">kontakt@asasbemanning.se</a>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>

            <div class="container">
                <nav>
                    <table width="100%">
                        <tr>
                            <td>
                                <router-link to="/" draggable="false" ondragstart="return false;"><span>Hem</span></router-link>
                                <router-link to="/information" draggable="false" ondragstart="return false;"><span>Information</span></router-link>
                                <router-link to="/uppdrag" draggable="false" ondragstart="return false;"><span>Uppdrag</span></router-link>
                                <router-link to="/anlita_oss" draggable="false" ondragstart="return false;"><span>Anlita Oss</span></router-link>
                                <router-link to="/kontakta_oss" draggable="false" ondragstart="return false;"><span>Kontakta Oss</span></router-link>
                            </td>
                            <td align="right">
                                <router-link to="/mina_sidor" draggable="false" ondragstart="return false;" class="end-piece"><span>Mina Sidor</span></router-link>
                            </td>
                        </tr>
                    </table>
                </nav>
            </div>
        </div>
    <router-view></router-view>
    <Footer />
    </div>
</template>


<style scoped>
    @import url("./assets/css/index.module.css");
</style>

<script>
    import Footer from './components/Footer.vue'
    import VueRouter from 'vue-router'
    import img1 from "./assets/img/dylan-gillis-533818-unsplash.jpg";
    import img2 from "./assets/img/demorris-byrd-K8RAfoZxoYI-unsplash.jpg";
    import img3 from "./assets/img/pavan-trikutam-1660-unsplash.jpg";
    import img4 from "./assets/img/helloquence-61189-unsplash.jpg";
    import img5 from "./assets/img/iStock-474451428.jpg";
    import img6 from "./assets/img/nik-macmillan-280300-unsplash.jpg";

    export default {
        name: 'index',
        mounted() {
            window.addEventListener("load", function () {
                new Image().src = img1;
                new Image().src = img2;
                new Image().src = img3;
                new Image().src = img4;
                new Image().src = img5;
                new Image().src = img6;
            });

            if(window.mobilecheck()) {

            }
            else {
                const links = document.getElementById("navigation").getElementsByTagName("a");
                for (let i = 0; links[i]; i++) {
                    if (links[i].href == window.location.href) {
                        links[i].setAttribute("id", "current_page");
                        break;
                    }
                }
            }
        },
        watch: {
            '$route' (to, from) {
                if(window.mobilecheck())
                    return false;
                const links = document.getElementById("navigation").getElementsByTagName("a");
                for (let i = 0; links[i]; i++) {
                    if (links[i].href == window.location.href && links[i].href.replace("mina_sidor", "") == links[i].href) {
                        this.change_url({target: links[i]})
                    }
                    else if (links[i].href == window.location.href) {
                        this.change_url({target: links[i]}, "left")
                    }
                }
            }
        },
        data () {
            return {
                mobile: window.mobilecheck()
            }
        },
        components: {Footer},
        methods: {
            open_mobile_menu: function () {
                if(document.getElementById("mobile_menu_links").getAttribute("class") === "open") {
                    document.getElementById("mobile_menu_links").setAttribute("class", "");
                }
                else {
                    document.getElementById("mobile_menu_links").setAttribute("class", "open");
                }
            },
            change_url: function (e, direction) {
                if(window.mobilecheck()) {
                    this.open_mobile_menu();
                }
                else {
                    let last_page = document.getElementById("last_page_left");
                    let current_page = document.getElementById("current_page");
                    if (!last_page) last_page = document.getElementById("last_page_right");
                    if (!current_page) {
                        current_page = document.getElementById("current_page_left");
                    }
                    if (!current_page) {
                        current_page = document.getElementById("current_page_right");
                    }
                    let new_current_page = e.target;
                    while (new_current_page.nodeName.toLocaleLowerCase() != "a") {
                        new_current_page = new_current_page.parentNode;
                    }

                    if (!direction) {
                        let container = new_current_page.parentNode;
                        if (container.childElementCount != 1) {
                            container = container.childNodes;
                            for (let i = 0; container[i]; i++) {
                                if (container[i] == new_current_page) {
                                    direction = "right";
                                    break;
                                } else if (container[i] == current_page) {
                                    direction = "left";
                                    break;
                                }
                            }
                        } else {
                            direction = "right";
                        }
                    }

                    if (!!last_page) last_page.setAttribute("id", "");
                    if (new_current_page != current_page) {
                        if (!!current_page) current_page.setAttribute("id", "last_page_" + direction);
                        new_current_page.setAttribute("id", "current_page_" + direction);
                    }
                }
            }
        }
    }
</script>

